var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquareCheck = function SvgSquareCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "square-check_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 3H3v18h18zm-4.034 6.447-1.818-1.818-5.21 5.21-1.52-1.52L6.6 13.139l3.337 3.337z",
    clipRule: "evenodd"
  })));
};
export { SvgSquareCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxIDNIM1YyMUgyMVYzWk0xNi45NjYgOS40NDY4NUwxNS4xNDc3IDcuNjI4NTdMOS45Mzc1OSAxMi44MzkyTDguNDE4MjcgMTEuMzE5N0w2LjYgMTMuMTM4TDkuOTM3NDMgMTYuNDc1NEwxNi45NjYgOS40NDY4NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";